module.exports = __webpack_public_path__ + "media/packs/images/flags/GH-439ec270d30917cc60ee70e282864af7.svg";